import type { Match } from '@uefadigital/panenka';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { useGetSponsorsByCompetitionAndPhaseQuery } from 'api/sponsorsApi';
import useIsDesktop from 'hooks/useIsDesktop';
import type { Sponsors as Sponsor } from 'types/ApiResponseInterfaces';
import { translateEntity } from 'utils/translateEntity';

export interface MatchProps {
  matchData: Match;
  isAvailableLinks?: boolean;
}

export const Sponsors = ({ matchData, isAvailableLinks = true }: MatchProps) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const TILE_WIDTH = isDesktop ? '?imwidth=74' : '?imwidth=83';

  enum SponsorType {
    GLOBAL = 'GLOBAL',
    LOCAL = 'LOCAL',
  }

  const {
    data: sponsors = [],
    isLoading: sponsorsLoading,
    isError: sponsorsError,
  } = useGetSponsorsByCompetitionAndPhaseQuery(`${matchData.competition.id}:${matchData.round?.phase}`);

  if (sponsorsLoading || sponsorsError || !sponsors.length) return <div />;

  const sponsorItem = (sponsor: Sponsor, i: number, availableLink: boolean) => {
    return (
      <div className="pk-mr--xs2 pk-mb--xs2" key={i}>
        {availableLink ? (
          <a href={sponsor.links[i18n.language.toUpperCase()]} target="_blank" rel="noreferrer">
            <img
              src={sponsor.image + TILE_WIDTH}
              alt={sponsor.name}
              width={isDesktop ? 74 : 83}
              height={isDesktop ? 41 : 46}
            />
          </a>
        ) : (
          <img src={sponsor.image} alt={sponsor.name} width={isDesktop ? 74 : 83} height={isDesktop ? 41 : 46} />
        )}
      </div>
    );
  };

  return (
    <div
      className={`${
        isDesktop ? 'pk-pb--xl2' : ''
      } pk-d--flex pk-align-items--center pk-container pk-mt--0 pk-pt--0 pk-flex--column`}
    >
      <p
        className={`${
          isDesktop ? 'pk-line-height--sm' : 'pk-line-height--md'
        } pk-text--uppercase pk-text--ui-04 pk-my--m pr-font-size--12 pk-font--base-bold`}
      >
        {translateEntity(matchData?.competition)?.name} {t('official_sponsors')}
      </p>
      <div
        className={`${isDesktop ? 'pk-mb--xl2' : 'pk-mb--s'} pk-justify-content--center
         pk-d--flex pk-align-items--center pk-flex--wrap  pr-mb--0`}
      >
        {sponsors
          .filter((s: Sponsor) => s.type === SponsorType.GLOBAL)
          .map((sponsor, i) => sponsorItem(sponsor, i, isAvailableLinks))}
      </div>
    </div>
  );
};
